import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const GoogleAuthSuccess = ({ chg }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extraire les paramètres de l'URL
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('token');
    const id = urlParams.get('id');
    const name = urlParams.get('name');
    const error = urlParams.get('error');

    if (error) {
      // Gérer l'erreur
      console.error('Erreur Google Auth:', error);
      setTimeout(() => {
        navigate('/Connexion?error=' + error);
      }, 2000);
      return;
    }

    if (token && id && name) {
      // Stocker les données utilisateur
      const userData = {
        token,
        id,
        name: decodeURIComponent(name),
        message: 'Connexion réussie !',
      };

      localStorage.setItem('userEcomme', JSON.stringify(userData));

      // Notifier le composant parent
      if (chg) {
        chg('oui');
      }

      // Rediriger après 2 secondes
      setTimeout(() => {
        const fromCart = urlParams.get('fromCart');
        const fromProfile = urlParams.get('fromProfile');
        const fromMore = urlParams.get('fromMore');
        const fromMessages = urlParams.get('fromMessages');

        if (fromCart) {
          navigate('/panier?fromCart=true');
        } else if (fromProfile) {
          navigate('/Compte?fromProfile=true');
        } else if (fromMore) {
          navigate('/More?fromMore=true');
        } else if (fromMessages) {
          navigate('/Messages?fromMessages=true');
        } else {
          navigate('/Home');
        }
      }, 2000);
    }
  }, [location, navigate, chg]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f9fafb',
        padding: '20px',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px',
          textAlign: 'center',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          maxWidth: '400px',
          width: '100%',
        }}
      >
        <div
          style={{
            marginBottom: '20px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CheckCircle size={64} color="#008751" />
        </div>
        <h2
          style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#333',
            marginBottom: '10px',
          }}
        >
          Connexion réussie !
        </h2>
        <p style={{ color: '#666', fontSize: '16px', marginBottom: '20px' }}>
          Vous allez être redirigé dans un instant...
        </p>
        <div
          style={{
            width: '100%',
            height: '4px',
            backgroundColor: '#e0e0e0',
            borderRadius: '2px',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              backgroundColor: '#008751',
              animation: 'progress 2s ease-in-out',
            }}
          />
        </div>
      </div>
      <style>
        {`
          @keyframes progress {
            from {
              transform: translateX(-100%);
            }
            to {
              transform: translateX(0);
            }
          }
        `}
      </style>
    </div>
  );
};

export default GoogleAuthSuccess;
